module.exports = __webpack_public_path__ + "static/media/logos-securises-commencer.3eac4608.png";